import { useStore } from 'src/contexts/StoreContext';
import { EditLookupToolbarProps } from '../EditLookupToolbar.types';
import { useMemo } from 'react';
import { ProductOptionModel } from 'src/store/_models/productOption';
import { EDIT_TOOLS } from '../../base-toolbar/BaseToolbar.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { getAvailableEditTool } from '../EditLookupToolbar.constants';
import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { parseAnalyticsParamsByUserImageArea } from 'src/_shared/analytics.utils';
export const useReplaceToolLogic = ({ onOpenTool, onCloseTool }: EditLookupToolbarProps) => {
  const {
    project: { activeUserImageArea },
    dynamicModal: { openModal },
  } = useStore();

  return useMemo(
    () => ({
      tool: ProductOptionModel.create({
        code: EDIT_TOOLS.replace,
      }),
      onOpenTool: async () => {
        openModal({
          dynamicModalView: DYNAMIC_MODAL_VIEWS.UploadMultiSource,
          newUploadMultiSourceCallback: params => {
            // TODO: need to wait SDK new replaceImageV2
            // if (params?.fileIds?.length > 0) {
            // activeUserImageArea?.userImage?.replaceImageV2(params?.fileIds?);
            // }
          },
        });
        amplitude.trackEvent(
          AnalyticsEvents.modifyPhoto.replaceClick,
          parseAnalyticsParamsByUserImageArea(activeUserImageArea),
        );
        return {
          canBeSelected: false,
        };
      },
      onCloseTool,
      ToolOptionsRenderer: getAvailableEditTool(EDIT_TOOLS.replace)?.ToolOptionsRenderer,
    }),
    [onOpenTool, onCloseTool],
  );
};
